@for (column of columns(); track column) {
    <td class="custom-table-td">
        @switch (column.field) {
            @case (dashboardExpiringSamplesColumnsEnum.SAMPLE) {
                <div>
                    <app-ellipsis-tooltip [paragraphId]="'expiring-samples-sample-name-' + sample().id">
                        {{ sample().sampleName }}
                    </app-ellipsis-tooltip>
                </div>
            }
            @case (dashboardExpiringSamplesColumnsEnum.LAST_USED) {
                <div class="center-td-content">
                    <p [id]="'expiring-samples-date-created-' + sample().id">
                        {{ sample().lastUsed ? (sample().lastUsed | date: 'MM/dd/YYYY') : '-' }}
                    </p>
                </div>
            }
            @case (dashboardExpiringSamplesColumnsEnum.STORAGE_DATE_END) {
                <div class="center-td-content">
                    <p [id]="'expiring-samples-date-created-' + sample().id">
                        {{ sample().storageDateEnd ? (sample().storageDateEnd | date: 'MM/dd/YYYY') : '-' }}
                    </p>
                </div>
            }
        }
    </td>
}
